// hide popup select country (app)
function getURLParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}
function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}
function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
    return null;
}
function removeURLParameter(param) {
    const url = new URL(window.location);
    url.searchParams.delete(param);
    window.history.replaceState(null, null, url.toString());
}
function searchElement() {
    const intervalTime = 100;
    const maxTime = 3000;
    let elapsedTime = 0;
    const interval = setInterval(() => {
        const element = document.querySelector('.needsclick');
        if (element) {
            element.style.display = 'none';
            clearInterval(interval);
        }
        elapsedTime += intervalTime;
        if (elapsedTime >= maxTime) {
            clearInterval(interval);
        }
    }, intervalTime);
}
function handleRedirect() {
    const redirectParam = getURLParameter('redirect');
    if(getCookie('redirectParam') === 'true'){
        removeURLParameter('redirect');
        searchElement();
    }else{
        if (redirectParam === 'true') {
            setCookie('redirectParam', 'true', 30);
            removeURLParameter('redirect');
            searchElement();
        }
    }
}
window.onload = handleRedirect;
// hide popup select country (app)
